import FuseScrollbars from '@fuse/core/FuseScrollbars';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectNavigation } from 'app/store/fuse/navigationSlice';
import Logo from '../../../../shared-components/Logo';
import NavbarToggleButton from '../../../../shared-components/NavbarToggleButton';
// import UserNavbarHeader from '../../../../shared-components/UserNavbarHeader';
import Navigation from '../../../../shared-components/Navigation';

const Root = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.navbar,
  color: theme.palette.text.navbar,
  '& ::-webkit-scrollbar-thumb': {
    boxShadow: `inset 0 0 0 20px ${
      theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.24)' : 'rgba(255, 255, 255, 0.24)'
    }`,
  },
  '& ::-webkit-scrollbar-thumb:active': {
    boxShadow: `inset 0 0 0 20px ${
      theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.37)' : 'rgba(255, 255, 255, 0.37)'
    }`,
  },
}));

const StyledContent = styled(FuseScrollbars)(({ theme }) => ({
  overscrollBehavior: 'contain',
  overflowX: 'hidden',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100% 40px, 100% 10px',
  backgroundAttachment: 'local, scroll',
}));

function NavbarStyle1Content(props) {
  const navigation = useSelector(selectNavigation);

  const { mainNavigation, bottomNavigation } = useMemo(() => {
    const bottomItemIds = new Set(['home-page-key', 'billing']);
    return {
      mainNavigation: navigation.filter((item) => !bottomItemIds.has(item.id)),
      bottomNavigation: navigation.filter((item) => bottomItemIds.has(item.id)),
    };
  }, [navigation]);

  return (
    <Root className={clsx('flex flex-auto flex-col overflow-hidden h-full', props.className)}>
      <Box
        className="flex flex-row items-center shrink-0 h-60 md:h-60 px-20"
        borderBottom="1px solid"
        borderColor="accent.200"
        marginBottom="20px"
      >
        <Box className="flex flex-1 mx-4">
          <Logo />
        </Box>

        <NavbarToggleButton className="w-40 h-40 p-0" />
      </Box>

      <StyledContent
        className="flex flex-1 flex-col min-h-0"
        option={{ suppressScrollX: true, wheelPropagation: false }}
      >
        {/* <UserNavbarHeader /> */}

        {/* <hr className="mb-24 mx-12" size={2} /> */}

        <Navigation layout="vertical" navigation={mainNavigation} />
      </StyledContent>

      {!!bottomNavigation.length && (
        <Box className="shrink-0 px-8 pb-12 pt-8">
          <Navigation layout="vertical" navigation={bottomNavigation} />
        </Box>
      )}
    </Root>
  );
}

export default memo(NavbarStyle1Content);
